import { BannerAnalyticsData } from '@analytics/const';
import { PromoAnalyticsService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { CmsSimpleResponsiveBannerComponent } from '@promo/const';
import { tabletImageGenerator } from '@promo/utils';
import { CmsComponentData, PageSlotComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-simple-responsive-banner',
  templateUrl: './simple-responsive-banner.component.html',
  styleUrls: ['./simple-responsive-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdSimpleResponsiveBannerComponent implements OnInit {
  componentData$: Observable<CmsSimpleResponsiveBannerComponent>;
  banner$: Observable<CmsSimpleResponsiveBannerComponent>;
  bannerAnalyticsData$: Observable<BannerAnalyticsData>;

  constructor(
    private component: CmsComponentData<CmsSimpleResponsiveBannerComponent>,
    private promoAnalyticsService: PromoAnalyticsService,
    @Optional() private pageSlotComponent: PageSlotComponent,
  ) {}

  ngOnInit(): void {
    this.componentData$ = this.component.data$.pipe(filter<CmsSimpleResponsiveBannerComponent>(Boolean));
    this.banner$ = this.componentData$.pipe(map(tabletImageGenerator));
    this.bannerAnalyticsData$ = this.componentData$.pipe(
      map((data: CmsSimpleResponsiveBannerComponent) => ({
        id: data.uid,
        name: data.name,
        position: this.pageSlotComponent.position,
      })),
    );
  }

  onBannerClick(): void {
    this.bannerAnalyticsData$.pipe(take(1)).subscribe((data: BannerAnalyticsData) => {
      this.promoAnalyticsService.onClickBanner(data);
    });
  }

  onBannerIntersect(): void {
    this.bannerAnalyticsData$.pipe(take(1)).subscribe((data: BannerAnalyticsData) => {
      this.promoAnalyticsService.onShowBanner(data);
    });
  }
}
